module.exports = __webpack_public_path__ + "static/media/pinterest.603e7eb0.svg";